import { render, staticRenderFns } from "./service-designer-chef-de-service.vue?vue&type=template&id=58d78b2e&scoped=true"
import script from "./service-designer-chef-de-service.vue?vue&type=script&lang=js"
export * from "./service-designer-chef-de-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d78b2e",
  null
  
)

export default component.exports